window.onload = function() {
  if (window.location.href.indexOf("?view=") > -1) {
    var selItem = sessionStorage.getItem("SelItem");  
    $('#perPage').val(selItem);
  }
};
$('#perPage').change(function() { 
  var selVal = $(this).val();
  sessionStorage.setItem("SelItem", selVal);
});


$(document).ready(function(){
  jQuery('#perPage').on('change', function(){
    window.location.replace(jQuery(this).val());
  });
});


var maxHeight = 0;
$(".logo-bar__item.each h2").each(function(){
   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
});
$(".logo-bar__item.each h2").height(maxHeight);


$('.collection-grid-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<svg width="40" height="40" aria-hidden="true" focusable="false" data-prefix="far" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-angle-left fa-4x"><path fill="currentColor" d="M166.5 424.5l-143.1-152c-4.375-4.625-6.562-10.56-6.562-16.5c0-5.938 2.188-11.88 6.562-16.5l143.1-152c9.125-9.625 24.31-10.03 33.93-.9375c9.688 9.125 10.03 24.38 .9375 33.94l-128.4 135.5l128.4 135.5c9.094 9.562 8.75 24.75-.9375 33.94C190.9 434.5 175.7 434.1 166.5 424.5z" class=""></path></svg>',
  nextArrow: '<svg width="40" height="40" aria-hidden="true" focusable="false" data-prefix="far" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-angle-right fa-4x"><path fill="currentColor" d="M89.45 87.5l143.1 152c4.375 4.625 6.562 10.56 6.562 16.5c0 5.937-2.188 11.87-6.562 16.5l-143.1 152C80.33 434.1 65.14 434.5 55.52 425.4c-9.688-9.125-10.03-24.38-.9375-33.94l128.4-135.5l-128.4-135.5C45.49 110.9 45.83 95.75 55.52 86.56C65.14 77.47 80.33 77.87 89.45 87.5z" class=""></path></svg>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 589,
      settings: "unslick"
    }
  ]
});




$('.testimonials-block-main').slick({
  dots: false,
  infinite: true,
  speed: 500,
  fade: true,
  autoplay: true,
  cssEase: 'linear',
});

if ($(window).width() < 768) {
  $(document).ready(function(){
    $('.footer-title-logo .footer__title').removeClass('small--hide');
  });
};


// if ($(window).width() > 600) {
//     $('.ftr_col').removeClass('grid--uniform');

// };

